export const RESOLUTION_PROPOSAL = "ActionProposal";
export const RESOLUTION_PROPOSAL_RECEIVED = "ActionProposalReceived";
export const RESOLUTION_PROPOSAL_IMPLEMENTED = "ActionProposalImplemented";
export const RESOLUTION_PROPOSAL_REJECTED = "ActionProposalRejected";
export const RESOLUTION_PROPOSAL_REQUEST = "ActionProposalRequest";
export const RESOLUTION_PROPOSAL_INVESTIGATION = "Investigation";
export const COMMENT_FROM_CUSTOMER = "CommentFromCustomer";
export const COMMENT_TO_CUSTOMER = "CommentToCustomer";
export const RESOLUTION_PROPOSAL_CLOSED = "Closed";



// WEBPACK FOOTER //
// ./src/incidents/comments/commentTypes.js